import { Link } from "@tanstack/react-router";
import { MessageSquare } from "lucide-react";
import { formatISODateRelative } from "lib/formatISODate";
import { FavoriteButton } from "./FavoriteButton";

interface DiscussionData {
    id: number;
    title: string;
    commentsCount: number;
    lastComment?: {
        author: { type: string; name: string };
        createdAt: string;
        isRead: boolean;
    };
}

export const DiscussionCard = ({
    discussion,
    target,
}: {
    discussion: DiscussionData;
    target?: string;
}) => {
    const lastComment = discussion.lastComment;
    const isUnread = lastComment != null && !lastComment.isRead;

    return (
        <Link
            to="/discussions"
            search={{ id: discussion.id }}
            target={target}
            className="block rounded-2xl border border-gray-200 bg-white p-4 no-underline shadow-sm transition-shadow hover:shadow-md"
        >
            <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                    <MessageSquare className="h-4 w-4 text-gray-500" />
                    <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-700">
                        Discussion
                    </span>
                    {isUnread && <span className="h-2 w-2 rounded-full bg-blue-500" />}
                </div>
                <FavoriteButton target={{ type: "discussion", id: discussion.id }} size={16} />
            </div>
            <h3 className="line-clamp-2 text-base font-semibold text-gray-900">
                {discussion.title}
            </h3>
            <div className="mt-2 flex items-center gap-2 text-xs text-gray-500">
                <span>{discussion.commentsCount} comments</span>
                {lastComment && (
                    <>
                        <span>·</span>
                        <span>
                            {lastComment.author.name} ·{" "}
                            {formatISODateRelative(lastComment.createdAt)}
                        </span>
                    </>
                )}
            </div>
        </Link>
    );
};
